import { DEFAULT_LOCATION } from '../constants/defaultLocation';
import api from './api';

const API_GATEWAY_URL_CONTENT = process.env.API_GATEWAY_URL_CONTENT;

const getHighlightVideo = (userId?: number | string) => {
  return api.get(
    `content/v1/contentCatalog/highlight-video?userId=${userId || 'anonymous'}`,
    {},
    false,
    false,
    false
  );
};

const getBannerHomepage = (userId?: number | string, city?: string, isUseGatewayAPI?: boolean) => {
  return api.get(
    `content/v1/contentCatalog/banner?userId=${userId || 'anonymous'}&city=${city || DEFAULT_LOCATION.citySlug?.toUpperCase()}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_CONTENT } : {}
  );
};

const getFlashSale = (userId: string, city: string, isUseGatewayAPI?: boolean) => {
  return api.get(
    `content/v1/contentCatalog/flash-sale?userId=${userId || 'anonymous'}&city=${city}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_CONTENT } : {}
  );
};

const getFlashSaleBanner = (pageId: string, componentId: string, isUseGatewayAPI?: boolean) => {
  return api.get(
    `content/v1/page/static-page?pageId=${pageId || ''}&componentId=${componentId || 'Auto2000FlashSaleImageBannerComponent'}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_CONTENT } : {}
  );
};

export default {
  getHighlightVideo,
  getBannerHomepage,
  getFlashSale,
  getFlashSaleBanner,
};
